/* ==========================================================================
   oddit-section-collection-slider
   Scroll progress bar for desktop horizontal scroll
   ========================================================================== */

(function () {
  var SECTION_SELECTOR = '.oddit-section-collection-slider';

  function initSection(section) {
    var track = section.querySelector('.oddit-section-collection-slider__track');
    var progressBar = section.querySelector('.oddit-section-collection-slider__progress-bar');

    if (!track || !progressBar) return;

    function updateProgress() {
      var scrollLeft = track.scrollLeft;
      var maxScroll = track.scrollWidth - track.clientWidth;

      if (maxScroll <= 0) {
        progressBar.style.width = '100%';
        return;
      }

      var progress = (scrollLeft / maxScroll) * 100;
      progressBar.style.width = Math.min(progress, 100) + '%';
    }

    track.addEventListener('scroll', updateProgress, { passive: true });

    // Drag-to-scroll (desktop / pointer devices)
    var isDragging = false;
    var dragMoved = false;
    var startX = 0;
    var startScrollLeft = 0;
    var pointerId = null;
    var DRAG_THRESHOLD = 5;

    function onPointerDown(e) {
      if (e.pointerType === 'touch') return; // let native touch scrolling handle it
      isDragging = true;
      dragMoved = false;
      startX = e.clientX;
      startScrollLeft = track.scrollLeft;
      pointerId = e.pointerId;
      track.classList.add('is-dragging');
    }

    function onPointerMove(e) {
      if (!isDragging || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;
      if (!dragMoved && Math.abs(dx) > DRAG_THRESHOLD) {
        dragMoved = true;
        try { track.setPointerCapture(pointerId); } catch (err) {}
      }
      if (dragMoved) {
        e.preventDefault();
        track.scrollLeft = startScrollLeft - dx;
      }
    }

    function endDrag(e) {
      if (!isDragging) return;
      if (e && pointerId !== null) {
        try { track.releasePointerCapture(pointerId); } catch (err) {}
      }
      isDragging = false;
      pointerId = null;
      track.classList.remove('is-dragging');
    }

    function onClickCapture(e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);
    track.addEventListener('click', onClickCapture, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // Auto-fit titles that overflow their card width
    var MAX_TITLE_FONT_SIZE = 22;
    var MIN_TITLE_FONT_SIZE = 14;
    var titles = section.querySelectorAll('.oddit-section-collection-slider__card-title-below');

    function fitTitle(title) {
      title.style.fontSize = '';
      var size = MAX_TITLE_FONT_SIZE;
      while (title.scrollWidth > title.clientWidth + 1 && size > MIN_TITLE_FONT_SIZE) {
        size -= 1;
        title.style.fontSize = size + 'px';
      }
    }

    function fitAllTitles() {
      titles.forEach(fitTitle);
    }

    // Initial update
    updateProgress();
    fitAllTitles();

    // Re-calculate on resize
    var ro = new ResizeObserver(function () {
      updateProgress();
      fitAllTitles();
    });
    ro.observe(track);

    return {
      destroy: function () {
        track.removeEventListener('scroll', updateProgress);
        track.removeEventListener('pointerdown', onPointerDown);
        track.removeEventListener('pointermove', onPointerMove);
        track.removeEventListener('pointerup', endDrag);
        track.removeEventListener('pointercancel', endDrag);
        track.removeEventListener('pointerleave', endDrag);
        track.removeEventListener('click', onClickCapture, true);
        ro.disconnect();
      }
    };
  }

  var sectionState = new Map();

  document.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
    var state = initSection(section);
    if (state) sectionState.set(section, state);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) {
      var state = initSection(section);
      if (state) sectionState.set(section, state);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) {
      var state = sectionState.get(section);
      if (state) {
        state.destroy();
        sectionState.delete(section);
      }
    }
  });
})();